import React from "react";
import AffiliateBase from "../components/Affiliate/AffiliateBase";
import AffiliateCommission from "../components/Affiliate/AffiliateCommission";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

const Affiliate = () => {

	const userState = useSelector((state: ApplicationState) => state.user)
	const user = userState.info

	return (
		<>
			{true ? <AffiliateBase /> : <AffiliateCommission />}
			{/* {user?.phone === "0111111111" ? <AffiliateCommission /> : <AffiliateBase />} */}
		</>
	)
}

export default Affiliate;